import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Container,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
  Grid,
  Box,
} from "@mui/material";
import { Add, Remove } from "@mui/icons-material";
import { useAppConfig } from "../../context/AppConfigContext";

const FAQPage = () => {
  const [expanded, setExpanded] = useState(false);
  const [activeCategory, setActiveCategory] = useState("ordering");
  const navigate = useNavigate();
  const { config } = useAppConfig();
  const faq = config?.faq || { categories: [], questions: {} };

  useEffect(() => {
    document.title = "FAQ";
  }, []);

  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <Container maxWidth="md" sx={{ mt: 4 }}>
      <Typography
        variant="h4"
        gutterBottom
        textAlign="center"
        sx={{
          fontFamily: "'Moul', serif",
          fontSize: "2rem",
          color: "#515151",
        }}>
        Frequently asked questions
      </Typography>
      <Typography
        variant="body1"
        textAlign="center"
        gutterBottom
        sx={{ mb: 8, fontFamily: "'Inter', sans-serif", color: "#909090" }}>
        At CakeyHand, we're dedicated to providing you with an exceptional
        experience. If you don't find what you're looking for, please contact us
        directly – we’re always here to help!
      </Typography>

      <Grid container justifyContent="center" sx={{ mb: 3 }}>
        <Typography
          variant="h6"
          gutterBottom
          textAlign="center"
          sx={{
            fontFamily: "'Moul', serif",
            fontSize: "1rem",
            color: "#515151",
          }}>
          Select from below categories
        </Typography>
      </Grid>

      <Grid container spacing={2} justifyContent="center" sx={{ mb: 3 }}>
        {faq.categories.map((category) => (
          <Button
            key={category.id}
            variant={activeCategory === category.id ? "contained" : "outlined"}
            onClick={() => setActiveCategory(category.id)}
            sx={{
              mr: 1,
              mb: 2,
              borderRadius: "8px",
              backgroundColor:
                activeCategory === category.id ? "#fd7762" : "transparent",
              color: activeCategory === category.id ? "#fff" : "#909090",
              borderColor:
                activeCategory === category.id ? "#fd7762" : "#909090",
              "&:hover": {
                backgroundColor: "#fd7762",
                borderColor: "#fd7762",
                color: "#fff",
              },
            }}>
            {category.name}
          </Button>
        ))}
      </Grid>

      <Box>
        {(faq.questions[activeCategory] || []).map((faqItem) => (
          <Accordion
            key={faqItem.id}
            expanded={expanded === faqItem.id}
            onChange={handleAccordionChange(faqItem.id)}
            sx={{ mb: 2, borderRadius: "10px", boxShadow: "none" }}>
            <AccordionSummary
              expandIcon={expanded === faqItem.id ? <Remove /> : <Add />}
              sx={{
                fontWeight: "bold",
                fontFamily: "'Inter', serif",
                color: "#515151",
              }}>
              {faqItem.question}
            </AccordionSummary>
            <AccordionDetails
              sx={{ fontFamily: "'Open Sans', sans-serif", color: "#909090" }}>
              <Typography
                dangerouslySetInnerHTML={{ __html: faqItem.answer }}
              />
            </AccordionDetails>
          </Accordion>
        ))}
      </Box>

      <Box
        sx={{
          mt: 6,
          mb: 4,
          textAlign: "center",
          backgroundColor: "#fde5e3",
          p: 4,
          borderRadius: 2,
        }}>
        <Typography
          variant="h5"
          sx={{
            mb: 1,
            fontFamily: "'Moul', serif",
            color: "#515151",
            fontWeight: 600,
          }}>
          Still have questions?
        </Typography>
        <Typography
          variant="body1"
          sx={{
            fontFamily: "'Inter', sans-serif",
            color: "#515151",
            fontWeight: 600,
            fontSize: "14px",
          }}>
          Can’t find the answer you’re looking for? Send us a message and we'll
          get back to you with answers.
        </Typography>
        <Button
          variant="contained"
          sx={{
            mt: 3,
            backgroundColor: "#fd7762",
            borderRadius: "8px",
            "&:hover": { backgroundColor: "#fd7762cc" },
          }}
          onClick={() => navigate("/contact")}>
          Get in touch
        </Button>
      </Box>
    </Container>
  );
};

export default FAQPage;
